import { SvgIconProps } from './icon-props';

export default function Offers({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
			<path d="M29.84 17.68 14.44 2.27a.56.56 0 0 0-.37-.15H4.22A2.21 2.21 0 0 0 2 4.34v9.85a.48.48 0 0 0 .15.36L17.56 30a.52.52 0 0 0 .73 0l11.55-11.6a.51.51 0 0 0 0-.72zM17.93 28.87 3 14V4.34a1.19 1.19 0 0 1 1.22-1.19h9.64L28.75 18zM7 5.09a2.09 2.09 0 1 0 2.12 2.08A2.08 2.08 0 0 0 7 5.09zm0 3.14a1.06 1.06 0 1 1 1.1-1.06A1.05 1.05 0 0 1 7 8.23z" />
		</svg>
	);
}
